export default "__VITE_ASSET__CwuArF76__"